<div class="row content-container">
  <form [formGroup]="form" class="forms">
    <div class="row info-container white-box">
      <h2>{{titulo}}</h2>
      <div class="form-group" *ngIf="isShowLojas" >
        <span class="icon store"></span>
        <div class="inputs">
          <label for="lojaId">Loja do vendedor</label>
          <select formControlName="lojaId"
                  id="lojaId"
                  required
                  appShowErrorMessages
                  requiredMessage="Selecionar Loja do Vendedor é obrigatório"
                  name="lojaId"
                  class="form-control">
            <option value="" selected hidden>Selecione...</option>
            <option *ngFor="let loja of lojas" [value]="loja.id">{{ loja.nome }}</option>
          </select>
        </div>
      </div>
      <div class="form-group">
        <span class="icon user"></span>
        <div class="inputs">
          <label for="promotorId">Nome do Operador</label>
          <select formControlName="promotorId"
                  name="promotorId"
                  class="form-control"
                  id="promotorId"
                  required
                  appShowErrorMessages
                  requiredMessage="Selecionar Operador é obrigatório">
            <option value="" selected hidden>Selecione...</option>
            <option *ngFor="let vendedor of vendedores" value="{{ vendedor.id }}">{{ vendedor.nome }}</option>
          </select>
        </div>
      </div>
    </div>
  </form>
</div>

<app-new-modal-message #modalMessage title="Atenção!" [showFecharBtn]="false"></app-new-modal-message>
